import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as countrycitystatejson from 'countrycitystatejson';
import { AlertService } from 'src/app/_alert';
import { AuthService } from 'src/app/_services/auth.service';
import { LoginService } from 'src/app/_services/login.service';
import { ZipCodeService } from 'src/app/_services/zip-code.service';

interface Country {
  shortName: string;
  name: string;
}

@Component({
  selector: 'app-update-company',
  templateUrl: './update-company.component.html',
  styleUrls: ['./update-company.component.css']
})
export class UpdateCompanyComponent implements OnInit {
  companyUser: any;
  countries: Country[];
  states: any[];
  cities: string[];
  private countryData = countrycitystatejson;
  submitted: boolean = true;
  status: boolean = false;
  isLoading: boolean = false;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };
  breakpoint: number;

  constructor(
    private authService: AuthService,
    private loginService: LoginService,
    private alertService: AlertService,
    private zipCodeService: ZipCodeService,
    private router: Router
  ) {
    this.countries = this.getCountries();
  }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.loginService.allCompanyDetails('').subscribe((response: any[]) => {
      console.log(response);
      this.loginService.allBankDetails('', '')
        .subscribe((res: any[]) => {
          if (response.length == 0) {
            this.router.navigate(['/All/companydetails']);
          }
          this.companyUser = response;
          const comp = this.companyUser.length - 1;
          // var event = {}
          // event['value'] = this.companyUser[comp].state
          // this.onStateClick(event)
          const mockEvent = {
            target: { value: this.companyUser[comp].zipCode, }
          }
          this.onZipCodeChange(mockEvent);
          this.companyDetailsForm.disable();
          this.companyDetailsForm = new FormGroup(
            {
              CompanyName: new FormControl(this.companyUser[comp].companyName),
              CompanyRegistrationNumber: new FormControl(this.companyUser[comp].companyRegistrationNumber?.toString()),
              Address: new FormControl(this.companyUser[comp].address),
              District: new FormControl(this.companyUser[comp].district),
              Country: new FormControl(this.companyUser[comp].country),
              NatureOfBusiness: new FormControl(this.companyUser[comp].natureOfBusiness),
              TaxIdNumber: new FormControl(res[res.length - 1].companyTaxId),
              City: new FormControl(this.companyUser[comp].city),
              State: new FormControl(this.companyUser[comp].state),
              ZipCode: new FormControl(this.companyUser[comp].zipCode, [
                Validators.minLength(5),
                Validators.maxLength(5)
              ]),
              Street: new FormControl(this.companyUser[comp].street),
              CreatedBy: new FormControl(this.companyUser[comp].createdBy),
              CustomerId: new FormControl(this.companyUser[comp].customerId),
              isActive: new FormControl(this.companyUser[comp].isActive),
              CompanyId: new FormControl(this.companyUser[comp].companyId,)
            }
          )
        })
      this.isLoading = false;
    }, (err) => {
      console.log(err);
      this.isLoading = false;
    })

    // if (this.companyDetailsForm.value.Country) {
    //   this.states = this.getStatesByCountry(this.companyDetailsForm.value.Country);
    //   console.log(this.states)
    //   this.companyDetailsForm.get('State').enable();
    // }
    // else {
    //   this.text = 'Please select state first.';
    // }
  }

  // text: string;
  // onStateClick(event) {
  //   var state = event.value;
  //   console.log("statee", state);
  //   if (state) {
  //     this.cities = this.getCitiesByState(this.companyDetailsForm.value.Country, state);
  //     console.log(this.cities)
  //     this.companyDetailsForm.get('City').enable();
  //   }
  // }

  companyDetailsForm: FormGroup = new FormGroup(
    {
      CompanyName: new FormControl('', [Validators.required, Validators.maxLength(25)]),
      CompanyRegistrationNumber: new FormControl('', [Validators.required, Validators.maxLength(25)]),
      Address: new FormControl('', [Validators.required, Validators.maxLength(25)]),
      District: new FormControl('US', [Validators.required, Validators.maxLength(25)]),
      Country: new FormControl('US', [Validators.required]),
      NatureOfBusiness: new FormControl('', [Validators.required, Validators.maxLength(25)]),
      TaxIdNumber: new FormControl('', [Validators.required, Validators.maxLength(25)]),
      // City: new FormControl({ value: null, disabled: true }, [Validators.required, Validators.maxLength(25)]),
      City: new FormControl(''),
      State: new FormControl(''),
      ZipCode: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(5)
      ]),
      Street: new FormControl('abcd', [Validators.required, Validators.maxLength(25)]),
      CreatedBy: new FormControl('', [Validators.required]),
      CustomerId: new FormControl('', [Validators.required]),
      IsActive: new FormControl(true),
      CompanyId: new FormControl('', [Validators.required])
    }
  )

  onSubmit() {
    if (!this.status) {
      this.companyDetailsForm.enable();
      this.status = true;
    }
    else {
      this.submitted = true;
      this.isLoading = true;
      if (this.companyDetailsForm.valid) {
        const token = this.authService.getToken();
        this.loginService.updateCompanyDetails(this.companyDetailsForm.value, token)
          .subscribe((response) => {
            //this.authService.setCompanyDetails(response['data']);
            console.log(response['data']);
            this.alertService.success('Success!! Company Details updated SuccessFully.', this.options);
            this.companyDetailsForm.disable();
            setTimeout(() => {
              this.isLoading = false;
            }, 200);
            this.status = false;
          }, (err) => {
            console.log(err);
            this.alertService.error(err.error.errors.Messages[0], this.options);
            this.isLoading = false;
          })
      } else {
        console.log('please enter valid data');
        // this.alertService.error('Error :( Please Enter Valid Details !', this.options);
        this.isLoading = false;
      }
    }
  }

  get forms() {
    return this.companyDetailsForm.controls;
  }

  reset() {
    this.companyDetailsForm.disable();
    this.status = false;
  }

  onDelete() {
    const token = this.authService.getToken();
    const id = this.companyDetailsForm.value.CompanyId
    this.loginService.deleteCompanyDetails(id, token).subscribe((response) => {
      this.authService.deleteCompanyDetails();
      console.log(response);
      this.alertService.info('Company details deleted SuccessFully!', this.options);
    }, (error) => {
      console.log(error);
    })
  }


  getCountries() {
    return this.countryData.getCountries();
  }

  getStatesByCountry(countryShotName: string) {
    return this.countryData.getStatesByShort(countryShotName);
  }

  getCitiesByState(country: any, state: any) {
    return this.countryData.getCities(country, state);
  }

  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 400) ? 1 : 2;
  }

  onZipCodeChange(event) {
    var zip = event.target.value;
    this.cities = [];
    this.states = [];
    if (zip == null || zip.length == 0 || zip.length < 5)
      return;
    this.zipCodeService.getDetailByZip(zip).subscribe((data: any) => {
      console.log(data);
      if (data == null) {
        return;
      }
      this.cities = data.places.map((place: any) => place['city']);
      this.states = data.places.map((place: any) =>  place['state']);

      // Auto-select first City and State
    const firstCity = this.cities[0];
    const firstState = this.states[0];

    if (firstCity) {
      this.companyDetailsForm.get('City')?.setValue(firstCity);
    }

    if (firstState) {
      this.companyDetailsForm.get('State')?.setValue(firstState);
    }

      
    });
  }
}



